'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _class, _temp; /**
                    * # Beatle是什么
                    *
                    * Beatle是一套基于状态管理机制构建用户界面的框架。采用自底向上增量开发的设计。Beatle 的核心库关注视图结构和视图状态。同时Beatle借助一些前端优秀设计方案，帮你在开发前端应用时节省下大量时间。
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _path = require('path');

var _path2 = _interopRequireDefault(_path);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = require('react-router-dom');

var _renderRoutes = require('../core/renderRoutes');

var _renderRoutes2 = _interopRequireDefault(_renderRoutes);

var _warning = require('fbjs/lib/warning');

var _warning2 = _interopRequireDefault(_warning);

var _messages = require('../core/messages');

var _messages2 = _interopRequireDefault(_messages);

var _isPlainObject = require('../core/isPlainObject');

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _extractModules = require('../core/extractModules');

var _extractModules2 = _interopRequireDefault(_extractModules);

var _isReactComponent = require('../core/isReactComponent');

var _isReactComponent2 = _interopRequireDefault(_isReactComponent);

var _seed = require('../seed');

var _seed2 = _interopRequireDefault(_seed);

var _connect2 = require('./connect');

var _connect3 = _interopRequireDefault(_connect2);

var _route2 = require('./route');

var _route3 = _interopRequireDefault(_route2);

var _model = require('./model');

var _model2 = _interopRequireDefault(_model);

var _provider = require('./provider');

var _provider2 = _interopRequireDefault(_provider);

var _ajax = require('../utils/ajax');

var _ajax2 = _interopRequireDefault(_ajax);

var _action = require('../seed/action');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * ### 应用初始化依赖的配置项
 *
 * | 属性 | 描述 | 默认 |
 * |: ------ |: ------ |: ------ |
 * | name `String` | 应用实例名 | `app` |
 * | store `Object` | 应用数据中心的初始化数据 | `{}` |
 * | freeze `Boolean` | 状态数据是否保持冻结不可变，store为undefined时表示冻结 | N/A |
 * | middlewares `Array` | 应用数据处理中间件，通过中间件可以变更数据结果 | `[]` |
 * | ajax `Object` | 应用接口请求对象初始化依赖的配置项 | `{}` |
 * | root `DOM` | 应用唯一挂载的DOM树节点 | `document.body` |
 * | base `String` | 应用启动，路由访问的根路径 | N/A |
 * | query `Object` | 设置路由全局参数 | N/A |
 * | autoLoadModel `Boolean` | 是否自动加载数据模型，如果开启则加载`assets/auto_models.js`文件 | `true` |
 * | autoLoadRoute `Boolean` | 是否自动加载路由，如果开启则加载`assets/auto_routes.js`文件 | `false` |
 * | models `Object︱Function︱Context` | 需要注册的数据模型 | N/A |
 * | routes `Object︱Function︱Context` | 需要注册的路由 | N/A |
 * | routeType `Boolean` | 路由处理器类型，主要分为hash还是原生 | `browserHistory` |
 * | subApp `Boolean` | 是否为子应用 | `false` |
 */
var beatleShape = {
  name: _propTypes2.default.string,
  freeze: _propTypes2.default.bool,
  store: _propTypes2.default.object,
  middlewares: _propTypes2.default.array,
  ajax: _propTypes2.default.object,
  root: _propTypes2.default.object,
  base: _propTypes2.default.string,
  env: _propTypes2.default.object,
  autoLoadModel: _propTypes2.default.bool,
  autoLoadRoute: _propTypes2.default.bool,
  models: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.array]),
  routes: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.array]),
  routeType: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string])
};
var SEP = '/';

var initialEntries = [{
  pathname: window.location.pathname,
  search: window.location.search
}];
var RouterByType = {
  localHistory: _reactRouterDom.MemoryRouter,
  hashHistory: _reactRouterDom.HashRouter,
  browserHistory: _reactRouterDom.BrowserRouter
};

var Beatle = (_temp = _class = function () {
  (0, _createClass3.default)(Beatle, [{
    key: '_getRouterProps',
    value: function _getRouterProps(routes, _basePath) {
      var _setting = this._setting,
          basePath = _setting.basePath,
          routeType = _setting.routeType,
          routePrompt = _setting.routePrompt;

      if (_basePath) {
        this._setting.basePath = _basePath;
      } else {
        _basePath = basePath;
      }
      return {
        initialEntries: routeType === 'localHistory' ? Object.keys(this.routesMap) : initialEntries,
        getUserConfirmation: routePrompt,
        basename: _basePath && _basePath[0] !== SEP ? SEP + _basePath : _basePath,
        children: (0, _renderRoutes2.default)(_basePath, routes.sort(function (a, b) {
          return a.fpath ? a.path > b.path ? -1 : 0 : 0;
        }))
      };
    }
    // #! 静态属性不对外开放，包括未初始化时的函数列表、默认应用实例、所有实例。

  }, {
    key: '_getRouter',
    value: function _getRouter(routeType) {
      var HistoryRouter = void 0;
      if (Object(routeType) === routeType) {
        /* eslint-disable react/prop-types, react/display-name */
        HistoryRouter = function HistoryRouter(_ref) {
          var children = _ref.children;

          return _react2.default.createElement(
            _reactRouterDom.Router,
            { history: routeType },
            children
          );
        };
      } else {
        HistoryRouter = RouterByType[routeType] || _reactRouterDom.BrowserRouter;
      }
      return HistoryRouter;
    }
  }]);

  function Beatle() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, Beatle);

    _propTypes2.default.checkPropTypes(beatleShape, options, 'BeatleOptions', 'Beatle');

    // #! 配置项初始化
    var name = options.name || 'app';
    this._setting = {
      basePath: options.base || '',
      query: options.env,
      level: options.level,
      appName: name,
      seedName: name + new Date().getTime(),
      rootDom: options.root || document.body,
      routes: [],
      routesMap: {},
      HistoryRouter: this._getRouter(options.routeType),
      routePrompt: options.routePrompt
    };
    this._middlewares = [];
    this.seed = null;
    this.ajax = null;
    this._hasRendered = false;
    this.injector = options.injector;
    this.globalInjector = options.globalInjector;

    Beatle.instances[this._setting.appName] = this;
    if (!options.subApp) {
      Beatle.defaultApp = this;
      Beatle.fireCallbacks[this._setting.appName] = (Beatle.fireCallbacks['__anonymous__'] || []).concat(Beatle.fireCallbacks[this._setting.appName] || []);
      delete Beatle.fireCallbacks['__anonymous__'];
    }

    // #! 初始化依赖模块
    this._init(options);

    this._fireReady();
  }

  (0, _createClass3.default)(Beatle, [{
    key: '_fireReady',
    value: function _fireReady() {
      /**
       * + 对于主应用，可以直接使用Beatle来使用应用实例的公开方法。
       *
       * ```
       *  // 设置数据模型
       *  Bealte.model(...)
       *  // 设置路由
       *  Beatle.route(...)
       *  // 以上还没有初始化应用, 而model和roue都是应用实例的方法，当应用实例不存在时会先注册到懒函数队列。
       *  const app = new Beatle({
       *    // 关键点在于设置main为true，表示当前应用是主应用
       *    main: true
       *  });
       *  app.model(...)
       *  app.run();
       * ```
       */
      // #! 触发注册的callback
      var callbacks = Beatle.fireCallbacks[this._setting.appName];
      if (callbacks) {
        for (var i = 0, len = callbacks.length; i < len; i++) {
          callbacks[i](this);
        }
      }
    }
  }, {
    key: '_init',

    /**
     * ### 初始化依赖模块
     *
     * 1. 自动加载数据模型
     * 2. 自动加载路由
     * 3. 初始化ajax模块
     * 4. 初始化redux模块，并装载Beatle的中间件
     */
    value: function _init(options) {
      // #! 自动加载数据模型
      var Models = void 0;
      if (options.models) {
        Models = options.models;
      } else if (options.autoLoadModel && Beatle.autoLoad.loadModels) {
        try {
          // #! 不能用require，因为查找不到编译就报错了，无法完整编译整个应用。
          Models = Beatle.autoLoad.loadModels();
        } catch (x) {
          window.console.error(x);
        }
      }

      if (!options.ajax || (0, _isPlainObject2.default)(options.ajax)) {
        this.ajax = new _ajax2.default(options.ajax);
      } else if (options.ajax) {
        this.ajax = options.ajax;
      }

      var middlewares = options.middlewares || [];
      middlewares.push(this._getMiddleWareFactory());
      this.seed = new _seed2.default({
        name: this._setting.seedName,
        freeze: options.freeze,
        initialState: options.store,
        middlewares: middlewares,
        Models: Models,
        ajax: this.ajax
      });

      // #! 自动加载路由
      if (options.autoLoadRoute && Beatle.autoLoad.loadRoutes) {
        try {
          this.routesFactory(Beatle.autoLoad.loadRoutes(), options);
        } catch (x) {
          window.console.error(x);
        }
      }
      if (options.routes) {
        this.setRoutes(options.routes, false, null, options);
      }

      Object.assign(this.injector._services, {
        ajax: this.ajax,
        app: this,
        seed: this.seed
      });
    }
  }, {
    key: '_getMiddleWareFactory',


    /**
     * ### 内部的方法，不对外开放
     *
     * | 方法 | 参数类型 | 描述 |
     * |: ------ |: ------ |: ------ |
     * | _getMiddleWareFactory() `void` | N/A | 构建一个redux中间件，把所有Beatle的中间组装进去 |
     * | _withBasename(basePath) `Object` | basePath `String` | 生成带有根路径的路由处理对象 |
     * | parseRoute(routeConfig) `Object` | routeConfig `Object` | 处理路由，app转路由也在这处理，并且添加到routesMap |
     */

    value: function _getMiddleWareFactory() {
      var _this = this;

      return function (store) {
        return function (next) {
          return function (action) {
            var callback = function callback(nextAction) {
              if (nextAction instanceof Error) {
                throw nextAction;
              }
              var middleware = _this._middlewares[callback.pos++];
              if (middleware) {
                middleware(nextAction, callback, store.dispatch);
              } else {
                next(nextAction);
              }
            };
            callback.pos = 0;
            callback(action);
          };
        };
      };
    }
  }, {
    key: '_parsePath',
    value: function _parsePath(path, name) {
      if (path) {
        path = path.replace('/:name', '/' + name);
      } else {
        path = name;
      }
      return path;
    }
  }, {
    key: '_convertAppToComponent',
    value: function _convertAppToComponent(appComponent, basePath, routeType) {
      var _class2, _temp2;

      var self = this;
      if (!appComponent.parent) {
        appComponent.parent = self;
        var baseName = basePath[0] === '/' ? basePath : self._setting.basePath + SEP + basePath;

        // 路由组件
        appComponent._setting.Router = this._getRouter(routeType || appComponent._setting.history);

        var key = void 0;
        var _routeCfg = void 0;
        // 相同路由下增加路径
        if (self._setting.HistoryRouter === appComponent._setting.HistoryRouter) {
          appComponent._setting.basePath = ''; // this._setting.basePath;
          appComponent.parent = self;
          for (key in appComponent._setting.routesMap) {
            _routeCfg = appComponent._setting.routesMap[key];
            // delete _routeCfg.resolvePath;
            if (_routeCfg.path && _routeCfg.path.indexOf('http') !== 0) {
              if (_routeCfg.path === SEP) {
                _routeCfg.path = basePath;
                _routeCfg.resolvePath = baseName;
              } else {
                if (_routeCfg.path[0] === SEP) {
                  _routeCfg.path = basePath + _routeCfg.path;
                  _routeCfg.resolvePath = baseName + _routeCfg.resolvePath;
                  if (_routeCfg.path[0] !== SEP) {
                    _routeCfg.path = SEP + _routeCfg.path;
                  }
                } else {
                  _routeCfg.path = baseName + SEP + _routeCfg.path;
                  _routeCfg.resolvePath = baseName + SEP + _routeCfg.resolvePath;
                }
              }
            }
          }
        } else {
          appComponent._setting.basePath = appComponent._getBasePath(baseName);
        }
      }

      var newComponent = (_temp2 = _class2 = function (_React$PureComponent) {
        (0, _inherits3.default)(newComponent, _React$PureComponent);

        function newComponent() {
          (0, _classCallCheck3.default)(this, newComponent);
          return (0, _possibleConstructorReturn3.default)(this, (newComponent.__proto__ || Object.getPrototypeOf(newComponent)).apply(this, arguments));
        }

        (0, _createClass3.default)(newComponent, [{
          key: 'render',
          value: function render() {
            var _this3 = this;

            var IRouter = appComponent._setting.HistoryRouter;
            var IProvider = (0, _provider2.default)(appComponent.injector, appComponent.globalInjector);
            return _react2.default.createElement(
              IProvider,
              { store: appComponent.getStore() },
              _react2.default.createElement(IRouter, (0, _extends3.default)({}, appComponent._getRouterProps(appComponent._setting.routes), { ref: function ref(inst) {
                  if (inst) {
                    _this3._activeHistory = inst.history;
                    /* eslint-disable react/no-find-dom-node */
                    _this3.storeContainer = _reactDom2.default.findDOMNode(inst);
                  }
                } }))
            );
          }
        }]);
        return newComponent;
      }(_react2.default.PureComponent), _class2.routeOptions = appComponent.routeOptions || {}, _temp2);

      return (0, _reactRouterDom.widthRouter)(newComponent);
    }
  }, {
    key: 'parseRoute',
    value: function parseRoute(routeConfig, strict) {
      var _this4 = this;

      // #! 如果设置路由是一个子App
      var parent = routeConfig;
      var paths = [];
      while (parent) {
        paths.unshift(parent.path);
        parent = parent.parent;
      }
      var basePath = paths.join(SEP);
      if (routeConfig.component) {
        routeConfig.component = Beatle.fromLazy(routeConfig.component, this);
        if (routeConfig.component instanceof Beatle) {
          routeConfig.path = routeConfig.path + '(/**)';
          routeConfig.component = this._convertAppToComponent(routeConfig.component, basePath, routeConfig.routeType);
        }
      } else if (routeConfig.getComponent && routeConfig.app) {
        routeConfig.path = routeConfig.path + '(/**)';
        var getComponent = routeConfig.getComponent;
        routeConfig.getComponent = function (nextState, callback) {
          var newCallback = function newCallback(err, app) {
            if (err) {
              callback(err, app);
            } else {
              callback(null, _this4._convertAppToComponent(app, basePath, routeConfig.routeType));
            }
          };
          getComponent(nextState, newCallback);
        };
      } else if (strict && !routeConfig.component.routeOptions) {
        routeConfig = false;
      }

      if (routeConfig) {
        this._setting.routesMap[this.getResolvePath(routeConfig, true)] = routeConfig;
      }
      return routeConfig;
    }

    /**
     * ### Beatle开放api
     *
     * | 方法 | 参数类型 | 描述 |
     * |: ------ |: ------ |: ------ |
     * | getStore() `Object` | N/A | 获取redux状态容器 |
     * | getRoutes() `Array` | N/A | 获取react-router的路由配置 |
     * | use(middleware) | middleware `Function` | 注册中间件，中间件是在处理处理过程中变更数据结构或者做一些必要的监控 |
     * | getResolvePath(routeConfig) `String` | routeConfig `Object` | 根据路由配置获取真实的路径 |
     * | route(path[, component]) | path `String︱Array︱Object︱Context`, component `ReactComponent` | 只有一个参数，此时为字符串则查找路由配置，否则是批量注册路由配置；2个参数未显示注册单个路由配置 |
     * | routesFactory(routes, option) | routes `Array︱Object︱Context`, option `Object` | 批量注册路由，可以传入option做更多处理 |
     * | setRoutes(routes, isAssign) `void`  | routes `Array︱Object︱Context`, isAssign `Boolean` | 批量路由注册 |
     * | model(Model) | Model `Object` | 注册数据模型 |
     * | connect(bindings, component[, flattern]) | bindings `String︱Object︱Array`, component `ReactComponent`, flattern `Boolean` | 设置视图, binding指定注入数据模型或者根据数据模型注入数据和方法 |
     * | run([rootDom, basePath]) | rootDom `Object`, basePath `String` | 启动应用 |
     */

  }, {
    key: 'getStore',
    value: function getStore() {
      return _seed2.default.getRedux(this._setting.seedName).store;
    }
  }, {
    key: 'getRoutes',
    value: function getRoutes() {
      return this._setting.routes;
    }
  }, {
    key: 'setRoutes',
    value: function setRoutes(routes, isAssign, parent, opt) {
      var _this5 = this;

      if (Array.isArray(routes)) {
        // 路由配置为数组时，实际上是react-router的路由配置
        if (isAssign) {
          this._setting.routes = routes;
        }
        // 需要遍历所有路由配置，包括父级、子级，都映射到routesMap，方便后续查找
        routes.forEach(function (item) {
          item.parent = parent;
          if (isAssign === false) {
            _this5._pushRoute(_this5._setting.routes, item, parent);
          }
          item = _this5.parseRoute(item);
          if (item.component && item.component.routeOptions) {
            Object.assign(item, item.component.routeOptions);
          }
          if (item.routes) {
            _this5.setRoutes(item.routes, null, item);
          }
        });
      } else {
        this.routesFactory(routes, opt);
      }
    }

    /**
     * ### 通过use方法可以注册中间件
     *
     * ```
     * // 以下中间件会添加了一个loadingBar的中间件
     * app.use((action, next, dispatch) => {
     *  // 通过action可以进行变更，生成新的nextAction
     *  if(action.type && !action.suppressGlobalProgress){
     *    if (action.type.match(/\/start$/)) {
     *      LoadingBar.showLoading()
     *    } else if (action.type.match(/\/success$/) || action.type.match(/\/error$/)) {
     *      LoadingBar.hideLoading()
     *    }
     *  }
     *  // next(nextAction) 把新的action传给侠哥中间件
     *  next(action);
     * });
     * ```
     */

  }, {
    key: 'use',
    value: function use(middleware) {
      this._middlewares.push(middleware);
    }
  }, {
    key: 'getResolvePath',
    value: function getResolvePath(routeConfig, flag) {
      var resolvePath = void 0;
      if (typeof routeConfig === 'string') {
        resolvePath = routeConfig;
      } else {
        /**
         * 3种情况，目的是要把路由路径打平
         * 1. route有resolvPath，说明已经处理过了
         * 2. route有path, 并且是绝对地址，此时resolvePath应为path
         * 3. route有path，如果有parent怎直接去path值，否则需要和navKey进行拼接
         */
        if (routeConfig.resolvePath) {
          resolvePath = routeConfig.resolvePath;
        } else if (routeConfig.path && (routeConfig.path[0] === '/' || routeConfig.path.indexOf('http') === 0)) {
          resolvePath = routeConfig.resolvePath = routeConfig.path;
        } else {
          var item = routeConfig;
          var paths = [];
          var ppath = void 0;
          while (item) {
            ppath = item.path || item.name;
            if (item.parent) {
              paths.unshift(ppath);
            } else {
              paths.unshift(item.navKey ? item.navKey + SEP + ppath : ppath);
            }
            item = item.parent;
          }
          resolvePath = _path2.default.normalize(paths.join(SEP));
          routeConfig.resolvePath = resolvePath;
        }
      }
      if (!flag) {
        if (resolvePath.indexOf('http') !== 0 && this._setting.basePath) {
          resolvePath = this._setting.basePath + SEP + resolvePath;
        }
      }
      return _path2.default.normalize(resolvePath);
    }
  }, {
    key: '_pushRoute',
    value: function _pushRoute(routes, childRoute, parent) {
      var _this6 = this;

      routes.push(childRoute);
      if (childRoute.aliasRoutes) {
        childRoute.aliasRoutes.forEach(function (r) {
          var path = r.path;
          r = Object.assign({ parent: parent }, childRoute, r);
          delete r.resolvePath;
          if (!path) {
            r.path = _this6._parsePath(r.path, r.name);
          }

          var resolvePath = _this6.getResolvePath(r, true);
          if (!_this6._setting.routesMap[resolvePath]) {
            _this6._setting.routesMap[resolvePath] = r;
            routes.push(r);
          }
        });
        delete this._setting.routesMap[childRoute.resolvePath];
        delete childRoute.resolvePath;
        childRoute.path = this._parsePath(childRoute.path, childRoute.name);
        this._setting.routesMap[this.getResolvePath(childRoute, true)] = childRoute;
      }
    }
    /**
     * ### 设置路由
     *
     * + 设置多个路由
     *
     * ```
     *  // 场景1： 格式为react-router路由配置项
     *  const routes = [
     *    { path: '/',
     *      component: App,
     *      indexRoute: { component: Dashboard },
     *      childRoutes: [
     *        { path: 'about', component: About },
     *        { path: 'inbox',
     *          component: Inbox,
     *          childRoutes: [
     *            { path: '/messages/:id', component: Message },
     *            { path: 'messages/:id',
     *              onEnter: function (nextState, replaceState) {
     *                replaceState(null, '/messages/' + nextState.params.id)
     *              }
     *            }
     *          ]
     *        }
     *      ]
     *    }
     *  ]
     *  app.route(routes);
     *
     * // 场景2：也可以是路由注册表
     * app.route({
     *  '/': App,
     *  '/message/:id': Message
     * })
     *
     * // 场景3：可以为require.context
     * app.route(require.context('../../assets', true, /\/index\.jsx?$/));
     * ```
     * + 获取指定路由
     *
     * ```
     *  const routeConfig = app.route('/');
     * ```
     * + 注册单个路由
     *
     * ```
     *  app.route('*', (props) => {
     *    return (<h1>404</h1>);
     *  });
     * ```
     */

  }, {
    key: 'route',
    value: function route(path, RouteComponent, routeConfig) {
      var _this7 = this;

      // #! 返回指定路由
      if (arguments.length === 1 && typeof path === 'string') {
        return this._setting.routesMap[path];
      }
      if (RouteComponent) {
        RouteComponent = Beatle.fromLazy(RouteComponent, this);
        // #! 设置路由
        if (routeConfig) {
          RouteComponent.routeOptions = Object.assign(RouteComponent.routeOptions || {}, routeConfig);
          if (routeConfig.routes) {
            this.setRoutes(routeConfig.routes, null, routeConfig);
          }
        }
        var childRoute = (0, _route3.default)(path, RouteComponent, {
          callback: this.parseRoute.bind(this),
          fromLazy: function fromLazy(com) {
            return Beatle.fromLazy(com, _this7);
          }
        });
        if (childRoute) {
          this._pushRoute(this._setting.routes, childRoute);
        }
      } else {
        // #! 设置多个路由
        var isAssign = RouteComponent === undefined ? true : !!RouteComponent;
        this.setRoutes(path, isAssign);
      }
    }
  }, {
    key: '_getName',
    value: function _getName(parentRoute, name, level) {
      if (level > 1) {
        for (; --level;) {
          name = parentRoute.name + '/' + name;
          parentRoute = parentRoute.parent;
        }
        return name;
      } else {
        return name;
      }
    }

    // ### 设置多个路由的具体实现

  }, {
    key: 'routesFactory',
    value: function routesFactory() {
      var _this8 = this;

      var routesMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      routesMap = (0, _extractModules2.default)(routesMap, function (module, key) {
        return key;
      });

      if (typeof option === 'function') {
        option = {
          callback: option
        };
      }
      var routeCallback = option.callback || this.parseRoute.bind(this);
      var level = option.level || 1;
      if (option.strict === undefined) {
        option.strict = true;
      }

      var routes = option.append ? this._setting.routes.slice(0) : [];
      /**
       * + 先要排序，把路径短的往前排
       *
       * ```
       *  // 比如一下map
       *  Map = {
       *    '/message/info': C,
       *    '/message/error/:404': D,
       *    '/message': B,
       *    '/': A
       *  }
       * // 排序之后
       * Map = {
       *  '/': A,
       *  '/message': B,
       *  '/message/info': C,
       *  '/message/error/:404': D
       * }
       * ```
       */
      Object.keys(routesMap).sort(function (a, b) {
        var compare = a.split(/[\\/]/).length - b.split(/[\\/]/).length;
        if (compare === 0) {
          return [-1, 1][(a > b) - 0];
        } else {
          return compare;
        }
      }).forEach(function (relativePath) {
        var keys = relativePath.slice(2, -10).split(/[\\/]/);
        // #! 把第一位空的剔除掉
        if (keys[0] === '') {
          keys.shift();
        }

        var Comp = Beatle.fromLazy(routesMap[relativePath], _this8);
        var key = void 0;
        var temp = void 0;
        var name = void 0;
        var children = void 0;
        var childRoute = void 0;

        // #! 路径短于指定级别时都认为一级路由处理
        if (keys.length < level) {
          childRoute = (0, _route3.default)(keys[0] || SEP, Comp, {
            name: keys[0] || SEP,
            strict: option.strict,
            callback: routeCallback,
            fpath: relativePath,
            fromLazy: function fromLazy(com) {
              return Beatle.fromLazy(com, _this8);
            }
          });
          if (childRoute) {
            _this8._pushRoute(routes, childRoute);
            _this8._pushRoute(_this8._setting.routes, childRoute);
          }
        } else {
          name = keys.pop();
          children = routes;
          var parentRoute = void 0;
          var navKey = keys[keys.length - 1] || '';
          // #! 查找是否注册过父级路由
          if (keys.length) {
            // 当前路由路径来决定应该在哪个子路由下
            while ((key = keys.shift()) && (temp = children.find(function (item) {
              return item.name === key;
            }))) {
              parentRoute = temp;
              children = parentRoute.routes || [];
            }
          }
          // #! 不存在父级路由，则直接挂在一级路由下
          if (!parentRoute) {
            parentRoute = children.find(function (item) {
              return item.name === SEP;
            });
            children = parentRoute.routes || [];
          }

          if (parentRoute) {
            parentRoute.routes = parentRoute.routes || [];
            childRoute = (0, _route3.default)(_this8._getName(parentRoute, parentRoute.path === navKey ? name : navKey + '/' + name, level), Comp, {
              name: name,
              navKey: navKey,
              strict: option.strict,
              callback: routeCallback,
              fpath: relativePath,
              parent: parentRoute,
              fromLazy: function fromLazy(com) {
                return Beatle.fromLazy(com, _this8);
              }
            });
            if (childRoute) {
              _this8._pushRoute(parentRoute.routes, childRoute);
            }
          } else {
            childRoute = (0, _route3.default)(null, Comp, {
              name: name,
              navKey: navKey,
              strict: option.strict,
              callback: routeCallback,
              fpath: relativePath,
              fromLazy: function fromLazy(com) {
                return Beatle.fromLazy(com, _this8);
              }
            });
            if (childRoute) {
              _this8._pushRoute(routes, childRoute);
              _this8._pushRoute(_this8._setting.routes, childRoute);
            }
          }
        }
      });
      return routes;
    }
  }, {
    key: 'model',
    value: function model(Model, Resource) {
      // #! 返回指定model
      if (typeof Model === 'string') {
        if (arguments.length === 1) {
          return this.seed.getModel(Model);
        } else {
          Resource.displayName = Model;
          Model = Resource;
          Resource = null;
        }
      }
      if (Model) {
        Model = Beatle.fromLazy(Model, this);
        // #! 不一定存在了，之前ES5和ES6混用时出现过。
        Model = Model.default || Model;
        if (!Model.displayName) {
          (0, _warning2.default)(false, _messages2.default.displayName, 'Model', 'arguments', 'beatleInstance.model');
          return;
        }

        (0, _model2.default)(Model, 'model');
        if (Resource) {
          this.seed.register(Model, Resource);
        } else {
          this.seed.register(Model);
        }
      } else {
        (0, _warning2.default)(false, _messages2.default.invalidValue, 'arguments', 'Model', Model, 'beatleInstance.model', 'ModelShape');
      }
    }
  }, {
    key: 'mount',
    value: function mount() {
      // #! todo
    }
  }, {
    key: 'connect',
    value: function connect(models, SceneComponent, flattern, props) {
      /**
       * ### connect模块来实现绑定
       *
       * + 场景1：支持原生的Redux#connect
       *
       * ```
       *  const mergeStateToProps = (state, ownProps) => {
       *  }
       *  const mergeDispatchToProps = (dispatch, ownProps) => {
       *  }
       *  app.connect([mergeStateToProps, mergeDispatchToProps], Component);
       * ```
       * + 场景2：注入整个数据模型
       *
       * ```
       *  app.model({
       *    displayName: 'user',
       *    store: {
       *      profile: {}
       *    },
       *    actions: {
       *      getUser
       *    }
       *  });
       *  // 在组件内部通过this.props.user获取到最新的store数据
       *  app.connect('user', Component);
       *  // 如果想通过this.props.profile拿到user#store#profile，实际上就是打平数据到组件中，而不是已this.props[modelName]来访问。
       *  app.connect('user', Component, true);
       *  // 如果注入多个数据模型
       *  app.connect(['user'], Component);
       * ```
       *
       * + 场景3：选择性通过数据模型注入数据
       *
       * ```
       *  app.connect({
       *    profile: 'user.state.profile',
       *    getUser: 'user.actions.getUser'
       *  }, Component)
       * ```
       */
      if ((0, _isReactComponent2.default)(models)) {
        SceneComponent = models;
        if (SceneComponent.getState) {
          models = function models(store, props) {
            return SceneComponent.getState(store['__pure_reducer__'], props);
          };
          flattern = true;
        } else {
          models = [];
        }
      }
      return (0, _connect3.default)(this.toBindings([].concat(models), flattern), this.dispatch.bind(this), props)(SceneComponent);
    }
  }, {
    key: 'toBindings',
    value: function toBindings(bindings, flattern, context) {
      var _this9 = this;

      // #! 从redux模块中获取model实例和所有的action
      var _ReduxSeed$getRedux = _seed2.default.getRedux(this._setting.seedName),
          store = _ReduxSeed$getRedux.store,
          actions = _ReduxSeed$getRedux.actions;

      var put = function put(name, state) {
        return _this9.put(name, state);
      };
      var select = function select(name, noFlattern) {
        return _this9.select(name, noFlattern);
      };
      return {
        flattern: flattern,
        dataBindings: typeof bindings[0] === 'function' ? bindings[0].bind(context) : function () {
          bindings._sign = {};
          return (0, _action.getStateByModels)({ state: store.getState(), actions: actions, put: put, select: select }, bindings, flattern, {
            state: function state(d) {
              return _this9.seed._isImmutable ? _this9.seed.serialize(d) : d;
            }
          }, bindings._sign);
        },
        eventBindings: typeof bindings[1] === 'function' ? function (dispatch, props) {
          return bindings[1].call(context, dispatch, props, actions);
        } : function (dispatch) {
          var iactions = (0, _action.getStateByModels)({ state: store.getState(), actions: actions, put: put, select: select }, bindings, flattern, {
            actions: function actions(_actions) {
              return (0, _action.getActionsByDispatch)(_actions, dispatch);
            }
          }, bindings._sign);
          delete bindings._sign;
          return iactions;
        }
      };
    }
  }, {
    key: 'getActions',
    value: function getActions(name) {
      var actions = this.seed.getActions(name);
      var store = this.getStore();
      var newActoins = {};

      var _loop = function _loop(key) {
        newActoins[key] = function () {
          return actions[key].apply(actions, arguments)(store.dispatch);
        };
      };

      for (var key in actions) {
        _loop(key);
      }
      return newActoins;
    }
    /**
     * ### 应用启动
     *
     * + 场景1：在new Beatle是已经配置了路由和挂在DOM，可直接启动应用
     *
     * ```
     *  app.run();
     * ```
     *
     * + 场景2：启动时即时配置DOM和跟路由
     *
     * ```
     *  app.run(document.body, 'example');
     * ```
     */

  }, {
    key: 'run',
    value: function run(rootDom, basePath, renderCb) {
      var _this10 = this;

      if (this._hasRendered) {
        return;
      }
      this._hasRendered = true;
      var IRouter = this._setting.HistoryRouter;
      // basePath, renderCb
      if (typeof rootDom === 'string' || !rootDom || !rootDom.nodeType) {
        renderCb = basePath;
        basePath = rootDom;
        rootDom = null;
      }
      if (typeof basePath === 'function') {
        // router, renderCb
        if ((0, _isReactComponent2.default)(basePath)) {
          IRouter = basePath;
          basePath = null;
        } else {
          // renderCb
          renderCb = basePath;
          basePath = null;
        }
      }

      var routes = this._setting.routes;
      rootDom = rootDom || this._setting.rootDom;
      var IProvider = (0, _provider2.default)(this.injector, this.globalInjector);
      var appElement = _react2.default.createElement(
        IProvider,
        { store: this.getStore() },
        _react2.default.createElement(IRouter, (0, _extends3.default)({}, this._getRouterProps(routes, basePath), { ref: function ref(inst) {
            if (inst) {
              _this10._activeHistory = inst.history;
              _this10.storeContainer = _reactDom2.default.findDOMNode(inst);
            }
          } }))
      );
      if (renderCb) {
        renderCb(appElement, rootDom);
      } else {
        _reactDom2.default.render(appElement, rootDom);
      }
    }
  }, {
    key: 'appName',
    get: function get() {
      return this._setting.appName;
    }
  }, {
    key: 'basename',
    get: function get() {
      return this._setting.basePath;
    }
  }, {
    key: 'setting',
    get: function get() {
      return this._setting;
    }
  }, {
    key: 'dispatch',
    get: function get() {
      return _seed2.default.getRedux(this._setting.seedName).store.dispatch;
    }
  }]);
  return Beatle;
}(), _class.fireCallbacks = {}, _class.defaultApp = null, _class.instances = {}, _class.autoLoad = {}, _temp);
exports.default = Beatle;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/base/beatle.js
// module id = 175
// module chunks = 0